import React, { useState } from "react";
import {
  FormStep,
  Toast,
  TextInput,
  CardLabel,
  SubmitBar
} from "@egovernments/digit-ui-react-components";

const Checklist = ({ t, onSelect, formData, currStep }) => {
  const [showToast, setShowToast] = useState(null);
  const [pedestrianMinWidth, setPedestrianMinWidth] = useState(formData?.checklist?.pedestrianMinWidth || "");
  const [vehicularAccessMinWidth, setVehicularAccessMinWidth] = useState(formData?.checklist?.vehicularAccessMinWidth || "");
  const [openGreenSpaceMinArea, setOpenGreenSpaceMinArea] = useState(formData?.checklist?.openGreenSpaceMinArea || "");
  const [soakPitMinArea, setSoakPitMinArea] = useState(formData?.checklist?.soakPitMinArea || "");
  const [plotOrientation, setPlotOrientation] = useState(formData?.checklist?.plotOrientation || "");
  const [plotLayout, setPlotLayout] = useState(formData?.checklist?.plotLayout || "");
  
  let validation = {};
  const closeToast = () => setShowToast(null);
  const onSkip = () => onSelect();

  const handleSubmit = () => {
    let checklist = {
      pedestrianMinWidth: pedestrianMinWidth || "",
      vehicularAccessMinWidth: vehicularAccessMinWidth || "",
      openGreenSpaceMinArea: openGreenSpaceMinArea || "",
      soakPitMinArea: soakPitMinArea || "",
      plotOrientation: plotOrientation || "",
      plotLayout: plotLayout || "",
    }

    onSelect(currStep.key, checklist);
  };

  return (
    <React.Fragment>
      <FormStep
        cardStyle={{ boxShadow: 'none', padding: 0, border: 0 }}
        onSelect={handleSubmit}
        onSkip={onSkip}
        t={t}
      >
        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_PADESTERIAN_MIN_WIDTH")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="pedestrianMinWidth"
          value={pedestrianMinWidth}
          onChange={(e) => setPedestrianMinWidth(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />
        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_VEHICULAR_ACCESS_MIN_WIDTH")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="vehicularAccessMinWidth"
          value={vehicularAccessMinWidth}
          onChange={(e) => setVehicularAccessMinWidth(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />
        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_OPEN_GREEN_SPACE_MIN_AREA")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="openGreenSpaceMinArea"
          value={openGreenSpaceMinArea}
          onChange={(e) => setOpenGreenSpaceMinArea(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />
        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_SOAK_PIT_MIN_AREA")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="soakPitMinArea"
          value={soakPitMinArea}
          onChange={(e) => setSoakPitMinArea(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />
        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_PLOT_ORIENTATION")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="plotOrientation"
          value={plotOrientation}
          onChange={(e) => setPlotOrientation(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />

        <CardLabel>{`${t("BPA_CHECKLIST_OPTION_PLOT_LAYOUT")}`}</CardLabel>
        <TextInput
          t={t}
          type={"text"}
          isMandatory={false}
          optionKey="i18nKey"
          name="plotLayout"
          value={plotLayout}
          onChange={(e) => setPlotLayout(e.target.value)}
          {...(validation = {
            isRequired: true,
            pattern: "^[a-zA-Z-.`' ]*$",
            type: "text",
            title: t("PT_NAME_ERROR_MESSAGE"),
          })}
        />
        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={handleSubmit} style={{ marginTop: '1rem' }} />
      </FormStep>
      {showToast && <Toast error={true} label={t(showToast?.message)} isDleteBtn={true} onClose={closeToast} />}
    </React.Fragment>
  );
};

export default Checklist;
